import { Component, OnInit } from '@angular/core';
import { some } from 'lodash';
import { DeclarationsService } from 'src/app/data/declaration/services/declarations/declarations.service';
import { DeclarationDr } from 'src/app/data/declaration/models/declaration-dr.model';
import { DeclarationSV12 } from 'src/app/data/declaration/models/declaration-sv12.model';
import { DeclarationSV11 } from 'src/app/data/declaration/models/declaration-sv11.model';
import { SessionContext, NavigationContext } from 'src/app/core/services/config/app.settings';
import { Campagne } from 'src/app/data/declaration/models/campagne.model';
import { forkJoin } from 'rxjs';
import { DeclarationDpCave } from 'src/app/data/declaration/models/declaration-dp-cave.model';
import { DeclarationDpNego } from 'src/app/data/declaration/models/declaration-dp-nego.model';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { RefCampagnesService } from 'src/app/data/declaration/services/ref-campagnes/ref-campagnes.service';
import { UtilisateurTypeCode } from 'src/app/data/intervenant/models/enums/type-utilisateur.enum';
import { DeclarationDpRecoltant } from 'src/app/data/declaration/models/declaration-dp-recoltant.model';

@Component({
    selector: 'app-affichage-dr',
    templateUrl: './affichage-dr.component.html',
    styleUrls: ['./affichage-dr.component.scss'],
    standalone: false
})
export class AffichageDrComponent implements OnInit {
    public declarations: DeclarationDr[];
    public declarationsSv11: DeclarationSV11[];
    public declarationsSv12: DeclarationSV12[];
    public declarationsDpCave: DeclarationDpCave[];
    public declarationsDpNego: DeclarationDpNego[];
    public declarationsDpRecoltant: DeclarationDpRecoltant[];
    public hasErrors = false;
    public refCampagnes: Campagne[];

    searchForm: UntypedFormGroup;

    get annee() {
        return this.searchForm.get('annee');
    }

    get idIntervenant(): number {
        if (NavigationContext.has('idOperateur')) {
            return NavigationContext.get('idOperateur');
        } else {
            return SessionContext.get('idIntervenant');
        }
    }

    constructor(
        private readonly declarationsService: DeclarationsService,
        private readonly refCampagnesService: RefCampagnesService,
        private readonly route: ActivatedRoute,
        private readonly router: Router,
        private readonly fb: UntypedFormBuilder
    ) {}

    ngOnInit() {
        this.searchForm = this.fb.group({
            annee: [undefined, [Validators.required, Validators.pattern(/(19|20)\d\d/)]]
        });

        if (NavigationContext.get('idOperateur') === undefined && SessionContext.get('utilisateurType') === UtilisateurTypeCode.ORGANISME) {
            this.router.navigate(['/main/operateurs/or/recherche-affilie']);
        } else {
            this.route.params.subscribe(vals => {
                const annee = vals.annee;
                if (annee && parseInt(annee)) {
                    this.annee.setValue(annee);
                    setTimeout(() => this.loadData());
                } else {
                    this.refCampagnesService.getCampagneEnCours().subscribe(campagne => {
                        this.annee.setValue(campagne.annee.toString());
                        setTimeout(() => this.loadData());
                    });
                }
            });

            this.annee.valueChanges.subscribe(annee => {
                if (this.annee.valid) {
                    if (SessionContext.get('utilisateurType') === UtilisateurTypeCode.ORGANISME) {
                        this.router.navigate(['main/operateurs/or/' + this.idIntervenant + '/dr/' + annee]);
                    } else {
                        this.router.navigate(['main/declarations/dr/' + annee]);
                    }
                }
            });
        }
    }

    private loadData() {
        forkJoin(this.declarationsService.getDeclarationsRecolte(this.idIntervenant, this.annee.value)).subscribe(
            ([declarations]) => {
                this.declarations = declarations.drs;
                this.declarationsSv11 = declarations.sv11s;
                this.declarationsSv12 = declarations.sv12s;
                this.declarationsDpCave = declarations.dpcaves;
                this.declarationsDpNego = declarations.dpnegos;
                this.declarationsDpRecoltant = declarations.dprecoltants;

                // eslint-disable-next-line max-len
                const list = [].concat(
                    this.declarations,
                    this.declarationsSv11,
                    this.declarationsSv12,
                    this.declarationsDpCave,
                    this.declarationsDpNego,
                    this.declarationsDpRecoltant
                ) as [DeclarationDr | DeclarationSV11 | DeclarationSV12 | DeclarationDpCave | DeclarationDpNego | DeclarationDpRecoltant];

                if (some(list, declaration => declaration && declaration.erreurs && declaration.erreurs.length > 0)) {
                    this.hasErrors = true;
                }
            },
            error => {
                try {
                    if (error.error.code === 'BACCHUS_BUSINESS_NO_DR') {
                        this.declarations = [];
                        this.declarationsSv11 = [];
                        this.declarationsSv12 = [];
                        this.declarationsDpCave = [];
                        this.declarationsDpNego = [];
                        this.declarationsDpRecoltant = [];
                        return;
                    }
                } catch (e) {
                    // eslint-disable-next-line @typescript-eslint/no-empty-function
                }
                throw error;
            }
        );
    }

    public goDrev() {
        if (this.annee.valid) {
            if (SessionContext.get('utilisateurType') === UtilisateurTypeCode.ORGANISME) {
                this.router.navigate(['main/operateurs/or/' + this.idIntervenant + '/drev/' + this.annee.value]);
            } else {
                this.router.navigate(['main/declarations/drev/' + this.annee.value]);
            }
        }
    }
}
